export class FilePath {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "isDirectory",
            "baseName": "isDirectory",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FilePath.attributeTypeMap;
    }
    constructor() {
    }
}
